import React from "react";
import { CLIENT_TYPES } from "../data/mock";

export const Clients = () => {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="py-24 lg:py-32 bg-ivory"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="gold-line" />
            <span className="text-xs tracking-[0.3em] uppercase text-navy/70 font-medium">
              Who We Serve
            </span>
          </div>
          <h2
            data-testid="clients-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy leading-[1.05] tracking-tight"
          >
            Clients who need
            <br />
            <span className="italic text-gold">financial clarity</span>{" "}
            in court.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {CLIENT_TYPES.map((client, idx) => {
            const Icon = client.icon;
            return (
              <div
                key={client.title}
                data-testid={`client-card-${idx}`}
                className="group relative bg-white border border-[#C0974E]/20 p-8 lg:p-10 hover:border-gold/60 transition-all duration-500 hover:shadow-xl hover:shadow-navy/5"
              >
                {/* Number watermark */}
                <span className="absolute top-6 right-6 font-serif text-6xl text-gold/10 group-hover:text-gold/30 transition-colors">
                  0{idx + 1}
                </span>

                <div className="relative z-10">
                  <Icon
                    className="w-8 h-8 text-gold mb-6"
                    strokeWidth={1.25}
                  />
                  <h3 className="font-serif text-2xl lg:text-3xl text-navy mb-3 leading-tight">
                    {client.title}
                  </h3>
                  <p className="text-base text-navy/70 leading-relaxed max-w-md">
                    {client.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
